import { GET, POST } from "@store/methods";

// saveAndGenerate
export const saveAndGenerate = ({ url, data }) => {
  return POST(`/${url}`, data, null, true);
};

// fetchRawFile
export const fetchRawFile = ({ url, data }) => {
  return POST(`/${url}`, data);
};

// fetchFinalFile
export const fetchFinalFile = ({ url, data }) => {
  return POST(`/${url}`, data, null, true);
};

// download file
export const downloadFile = ({ url, params }) => {
  return GET(`/${url}`, params, true);
};

// fetchRawAndFinalFileUrls
export const fetchRawAndFinalFileUrls = ({ url, params }) => {
  return GET(`/${url}`, params);
};

// regenerate
export const regenerate = (params) => {
  return GET(`/regenerate-imports-and-exports`, params);
};
